import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Hooks } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { connect, withIntl } from '@grandvisionhq/state';
import { pause, quantity } from '../../actions.js';
import { getPauseCall, getProductData, getProductDataCall, getQuantityCall } from '../../selectors.js';
import { CurrentPlan } from './CurrentPlan.js';
import { useGetPrescriptionSignatures } from './hooks/use-get-prescription-signatures.js';

const getEyeSide = (application)=>{
    if (!application.length) {
        return {};
    }
    if (application.length > 2) {
        return {
            eyeSide: 'both'
        };
    } else if (application.includes('LEFT_EYE')) {
        return {
            eyeSide: 'left'
        };
    } else {
        return {
            eyeSide: 'right'
        };
    }
};
const CurrentPlanContainer = (props)=>{
    const [addToCart, { loading  }] = Hooks.useAddToCart();
    const { prescriptionSignatures  } = useGetPrescriptionSignatures();
    const handleTopUp = ()=>{
        if (loading) {
            return;
        }
        const mapSolution = (lineItem)=>({
                sku: lineItem.productId,
                quantity: 1,
                type: 'regular'
            })
        ;
        const mapContactLenses = (lineItem)=>({
                sku: lineItem.productId,
                quantity: 1,
                type: 'contact-lenses',
                typeDetails: {
                    eyeSide: getEyeSide(lineItem.application).eyeSide
                }
            })
        ;
        const lineItemDrafts = props.subscription.lineItems.map((lineItem)=>// application contains an array with eyesides, only present for contact lenses
            lineItem.application.length ? mapContactLenses(lineItem) : mapSolution(lineItem)
        );
        const onError = (errorCodes)=>errorCodes.forEach((code)=>toast.failed(`cart.${code}`)
            )
        ;
        /**
     * We need to remove the existing cart because we can only send prescription signatures on
     * the `createCart` mutation. When the backend allows us to attach prescription signatures
     * to line items added to the cart, we won't have to do this anymore and can just keep the cart.
     */ window.localStorage.removeItem('stored_cart');
        // `undefined` is passed because `addToCart` expects parameters that we do want to use here.
        addToCart(lineItemDrafts, undefined, onError, (e)=>onError([
                e
            ])
        , undefined, undefined, undefined, undefined, {
            prescriptionSignatures
        });
    };
    return /*#__PURE__*/ React.createElement(CurrentPlan, swcHelpers.extends({}, props, {
        getEyeSide: getEyeSide,
        handleTopUp: handleTopUp,
        reorderLoading: loading
    }));
};
const mapStateToProps = (state)=>({
        pauseCall: getPauseCall(state),
        productData: getProductData(state),
        productDataCall: getProductDataCall(state),
        quantityCall: getQuantityCall(state)
    })
;
const mapDispatchToProps = {
    pause,
    quantity
};
var CurrentPlanContainer$1 = connect(mapStateToProps, mapDispatchToProps)(withIntl(CurrentPlanContainer));

export { CurrentPlanContainer, CurrentPlanContainer$1 as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=CurrentPlanContainer.js.map
